<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form @submit.prevent="load">
          <b-form-row>
            <lg-form-const-select label="Situação:" cols="12" sm="4" md="2" v-model="form.situacao" @change="load"
              :options="optionsFilterSituacao" />
            <lg-form-input v-model="form.descricao" label="Descrição:" description=" " cols="12" sm="8" md="10" />
          </b-form-row>
          <b-form-row>
            <b-col cols="12" class="text-right">
              <b-button id="localizarMarca" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary" @click="load()">
                <div class="btn-size-alinhamento">
                  <b-icon icon="search" />
                  <b-tooltip target="localizarMarca" title="Localizar" triggers="hover"></b-tooltip>

                </div>
              </b-button>
              <b-button v-if="temPrivilegioCriacao()" id="novoMarca" class="mr-2 my-2" size="sm" style="height: 20px" pill @click="abrirModalEdit" variant="primary">
                <div class="btn-size-alinhamento">
                  <b-icon scale="1" icon="plus" />
                </div>
                <b-tooltip target="novoMarca" title="Adicionar novo..." triggers="hover"></b-tooltip>

              </b-button>
            </b-col>
          </b-form-row>
        </b-form>
        <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
          :hover="true" @row-dblclicked="marcaSelect" show-empty>
          <template #empty>
            <p>Nenhum registro encontrado</p>
          </template>
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <template v-slot:cell(editar)="{ item }">
            <b-button :disabled="!temPrivilegioEdicao()"  :id="'editar-' + item.id" class="my-2" size="sm" pill variant="primary"
              @click="abrirModalEdit(item)">
              <b-icon icon="pencil-square" />
              <b-tooltip :target="'editar-' + item.id" title="Editar..." triggers="hover"></b-tooltip>
            </b-button>
          </template>
          <template v-slot:cell(situacao)="{ item }">
            <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="item.situacao" @change="alteraSituacao(item)" name="check-button" switch size="lg"
              :value="1" :unchecked-value="0" />
          </template>
        </b-table>
        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de {{
              totalPage }} -
              {{ total }} registros</b-col>
            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
              <b-form-select size="sm" v-model="perPage" @change="() => this.load()" :options="perPageOptions">
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                :total-rows="total"></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-card-body>
    <MarcaForm v-if="showModalEdit" @close="cancelar" :isModal="true" :id="id" :empresaNome="nomeEmpresa"
      :codEmpresa="codigoEmpresa" :prefix="updatedPrefix" />
  </b-card>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import MarcaForm from "./MarcaForm.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    MarcaForm,
  },
  data() {
    return {
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      filtro: {},
      showModalEdit: false,
      codigoEmpresa: this.codEmpresa || null,
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: "1" },
        { key: "filterSituacao", text: "Inativo", value: "0" },
      ],
      form: {
        descricao: "",
        situacao: "1",
      },
    };
  },
  props: {
    codEmpresa: Number,
    prefix: {
      Array,
      default: () => [],
    },
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/marca`);
  },
  mounted() {
    this.load();
  },
  watch: {
    page() {
      this.load();
    },
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Marca"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
    tableFields() {
      return [
        { key: "descricao", label: "Descrição" },
        { key: "editar", label: "", tdClass: "w-1 align-items-center" },
        { key: "situacao", label: "", tdClass: "w-1 align-items-center" },
      ];
    },
  },
  methods: {
    temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);
        },
        temPrivilegioCriacao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);
        },
    cancelar() {
      this.showModalEdit = false;
      this.id = null;
      this.nomeEmpresa = "";
      this.codigoEmpresa = null;
      this.load();
    },
    abrirModalEdit(item) {
      this.id = item.id;
      this.nomeEmpresa = item.razaoSocial;
      this.showModalEdit = true;
    },
    async load() {
      this.filtro = {};
      if (this.form.descricao) {
        this.filtro.descricao = this.form.descricao;
      }
      if (this.form.situacao != undefined) {
        this.filtro.situacao = this.form.situacao;
      }

      this.busy = true;

      await this.$loadResource({
        size: this.perPage,
        page: this.page,
        params: this.filtro,
      });
    },
    marcaSelect(item) {
      this.$emit("onDblClickMarca", item);
    },
    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " +
        (item.situacao === 1 ? "ativar" : "desativar") +
        " a Marca?",
        item.descricao.toUpperCase()
      );
      if (response == true) {
        this.confirmarAlteracaoSituacao(item);
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1;
      }
    },

    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item);
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        });
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        });
      }
    },
  },
};
</script>
